import type { ActivityDetailsPriceCriteria } from '@libs/trip-planner-interfaces';
import { GraphQL } from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getRecipeRequestContextQL } from './recipeQL';

export function getActivityDetailsPriceRequestQL(
  criteria: ActivityDetailsPriceCriteria
): GraphQL.CheapestStayByHotelRequestQL {
  const userCriteria = criteria.userCriteria;

  return {
    recipe: {
      ...getRecipeRequestContextQL({
        businessCriteria: criteria.businessCriteria,
        sessionId: userCriteria.sessionId,
        skipCache: userCriteria.skipCache,
      }),
      pax: [{ numberOfAdults: 1, childAges: [] }],
      ingredients: [
        {
          ingredientType: GraphQL.InputIngredientTypeQL.Hotel,
          hotelCodes: [userCriteria.productCode],
          selectedHotelTypes: [
            GraphQL.InputSelectedHotelTypesQL.Golf,
            GraphQL.InputSelectedHotelTypesQL.Ticket,
          ],
          numberOfNights: userCriteria.numberOfNights,
          boardBasis: [],
          heartedHotels: [],
        },
      ],
      startDateOnly: normalizeDateOnlyString(userCriteria.startDate),
      endDateOnly: normalizeDateOnlyString(userCriteria.endDate),
      selectedDate: normalizeDateOnlyString(userCriteria.selectedDate),
    },
    ingredientIndex: 0,
    constraint: {
      hotelCodes: [userCriteria.productCode],
    },
    day: normalizeDateOnlyString(userCriteria.selectedDate),
  };
}
